import React from 'react';
import PropTypes from 'prop-types';

import MaterialSelect from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import { Field } from 'redux-form';

import { onClickWrapper } from '../../../utils/ui';
import { connectTo } from '../../../utils';

class SelectField extends React.Component {
  static renderSelect = ({
    options,
    onChange,
    className,
    classNameInput,
    classNameRoot,
    classNameMenuItem,
    maxSelectHeight,
    input,
    value,
    multiple,
    iconComponent,
    translated,
    translations,
  }) => {
    return (
      <MaterialSelect
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: maxSelectHeight ? maxSelectHeight : 300,
            },
          },
          getContentAnchorEl: null,
        }}
        IconComponent={iconComponent && (() => iconComponent)}
        multiple={multiple}
        className={className}
        value={input ? input.value : value}
        classes={{
          select: classNameInput,
          root: classNameRoot,
        }}
        onChange={onClickWrapper(null, input ? input.onChange : onChange)}
      >
        {options.map(({ label, value, id }, key) => (
          <MenuItem
            {...{ value, key, id }}
            classes={{
              root: classNameMenuItem,
            }}
          >
            {translated ? translations[label] || '' : label}
          </MenuItem>
        ))}
      </MaterialSelect>
    );
  };

  render() {
    const {
      name,
      options,
      value,
      onChange,
      className,
      classNameInput,
      classNameRoot,
      classNameMenuItem,
      maxSelectHeight,
      multiple,
      iconComponent,
      validate,
      translated,
      translations,
    } = this.props;

    const customProps = {
      options,
      value,
      onChange,
      className,
      classNameInput,
      classNameRoot,
      classNameMenuItem,
      maxSelectHeight,
      multiple,
      iconComponent,
      translated,
      translations,
    };
    return name ? (
      <Field
        component={SelectField.renderSelect}
        name={name}
        onChange={onChange}
        props={customProps}
        value={value}
        validate={validate}
      />
    ) : (
      SelectField.renderSelect(customProps)
    );
  }
}

SelectField.propTypes = {
  name: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.any,
  hasForm: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  multiple: PropTypes.bool,
  iconComponent: PropTypes.element,
};

export default connectTo(
  ({ translations: { translations } }) => ({
    translations,
  }),
  {},
  SelectField
);
